import axios from 'axios';
import useTextCorrection from "../hooks/useTextCorrection";
import {TOKEN_EXPIRED} from "../hooks/useAPIHelper";

const SUBMIT_JOB_URL = '/.netlify/functions/xServicePostNewServiceCall';

const PostNewService = (inputs: {
  contractNo: string,
  issueTitle: string,
  location: string,
  customerReference: string,
  priorityCode: number,
  asset: string,
  name: string,
  phone: string,
  department: string,
  itemcode: string,
  serviceCentreCode: string,
  selectedCustomerId: string
}, token: string) => {
  const { fillSpacing } = useTextCorrection();

  const fetchData = async (): Promise<any> => {
    try {
      const response = await axios({
        method: 'POST',
        url: SUBMIT_JOB_URL,
        headers: {
          'Content-Type': 'application/json',
          'X-Pronto-Token': token,
        },
        data:
          `<TypeCode>RM</TypeCode>` +
          `<CallDescription>${inputs.issueTitle + ' - ' + inputs.location}</CallDescription>` +
          `<ContractNo>${fillSpacing(inputs.contractNo)}</ContractNo>` +
          `<CustomerCode>${inputs.selectedCustomerId}</CustomerCode>` +
          `<ServiceCentreCode>${inputs.serviceCentreCode}</ServiceCentreCode>` +
          `<CustomerReference>${inputs.customerReference}</CustomerReference>` +
          `<PriorityCode>${inputs.priorityCode}</PriorityCode>` +
          `<SerialNo>${inputs.asset}</SerialNo>` +
          `<CallerName>${inputs.name}</CallerName>` +
          `<CallerPhoneNo>${inputs.phone}</CallerPhoneNo>` +
          `<CallUserOnlyAlpha202>${inputs.department}</CallUserOnlyAlpha202>` +
          `<ItemCode>${inputs.itemcode}</ItemCode>`,
      });

      if (response.status === 200) {
        return response.data.ServicePostNewServiceCallResponse.Posted.ServiceCall.CallNo;
      }
    } catch (err) {
      if(err.response.status == 401) {
        if(err.response.data == 'TokenExpired') {
          throw(TOKEN_EXPIRED)
        }
      }
      throw(err);
    }
    return false;
  };

  return fetchData();
};

export default PostNewService;